type SortDirection = 'asc' | 'desc'

const Filter = {
  el: {
    root: null as HTMLElement | null,
    links: [] as HTMLButtonElement[],
    items: [] as HTMLElement[],
    resultCount: null as HTMLElement | null,
    sortButton: null as HTMLButtonElement | null,
    sortLabel: null as HTMLElement | null,
  },
  init() {
    this.setElements()

    if (this.el.root) {
      this.handleFilter()
      this.handleSort()
    }
  },
  setElements() {
    this.el.root = document.querySelector<HTMLElement>('.filter')
    this.el.links = Array.from(document.querySelectorAll<HTMLButtonElement>('.filter__link'))
    this.el.items = Array.from(document.querySelectorAll<HTMLElement>('[data-filter-item]'))
    this.el.resultCount = document.querySelector<HTMLElement>('[data-filter-result-count]')
    this.el.sortButton = document.querySelector<HTMLButtonElement>('[data-filter-sort-button]')
    this.el.sortLabel = document.querySelector<HTMLElement>('[data-filter-sort-label]')
  },
  handleFilter() {
    this.el.links.forEach((link) => {
      link.addEventListener('click', (e: Event) => {
        const target = e.currentTarget as HTMLButtonElement
        const filter = target.dataset.filter

        this.removeActive()
        this.onFilterChange()

        target.classList.add('active')

        if (!filter || filter === 'all') {
          this.showAll()
          return
        }

        this.showFiltered(filter)
      })
    })
  },
  handleSort() {
    const sortButton = this.el.sortButton

    if (sortButton) {
      if (sortButton.dataset.sortShowsNextDirection === 'true') {
        this.sortItems('asc')
        this.updateSortButton('asc')
      }

      sortButton.addEventListener('click', () => {
        const direction: SortDirection = sortButton.dataset.sortDirection === 'desc' ? 'asc' : 'desc'

        this.sortItems(direction)
        this.updateSortButton(direction)
      })
    }
  },
  removeActive() {
    this.el.links.forEach((link) => {
      link.classList.remove('active')
    })
  },
  onFilterChange() {
    document.dispatchEvent(new CustomEvent('filter:change'))
  },
  showFiltered(filter: string) {
    let count = 0

    this.el.items.forEach((item) => {
      const isVisible = item.dataset.filter === filter

      item.style.display = isVisible ? 'block' : 'none'

      if (isVisible) {
        count++
      }
    })

    this.updateResult(count)
  },
  showAll() {
    let count = 0

    this.el.items.forEach((item) => {
      item.style.display = 'block'
      count++
    })

    this.updateResult(count)
  },
  sortItems(direction: SortDirection) {
    const parent = this.el.items[0]?.parentElement

    if (!parent) {
      return
    }

    const items = [...this.el.items]

    items.sort((a, b) => {
      const aValue = a.dataset.filterSortValue || ''
      const bValue = b.dataset.filterSortValue || ''
      const comparison = aValue.localeCompare(bValue, undefined, { sensitivity: 'base' })

      return direction === 'asc' ? comparison : comparison * -1
    })

    items.forEach((item) => {
      parent.appendChild(item)
    })
  },
  updateSortButton(direction: SortDirection) {
    const sortButton = this.el.sortButton

    if (sortButton) {
      let displayedDirection = direction
      if (sortButton.dataset.sortShowsNextDirection === 'true') {
        displayedDirection = direction === 'asc' ? 'desc' : 'asc'
      }
      const label = displayedDirection === 'asc' ? sortButton.dataset.sortLabelAsc : sortButton.dataset.sortLabelDesc

      sortButton.dataset.sortDirection = direction
      sortButton.classList.toggle('order-by-button--desc', displayedDirection === 'desc')

      if (this.el.sortLabel && label) {
        this.el.sortLabel.innerText = label
      }
    }
  },
  updateResult(count: number) {
    if (this.el.resultCount) {
      this.el.resultCount.innerText = `${count}`
    }
  },
}

export default Filter
